import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Auth } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const AuthCallback = () => {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const hasProcessed = useRef(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/admin/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const me = await Auth.session(session_id);
        setUser(me);
        // Clean URL hash
        window.history.replaceState(null, "", window.location.pathname);
        // Route based on the intent stored before initiating login.
        let intent = "";
        try { intent = window.localStorage.getItem("atc-auth-intent") || ""; window.localStorage.removeItem("atc-auth-intent"); } catch { /* ignore */ }
        if (intent === "portal") {
          if (me.is_portal_member || me.is_admin) {
            navigate("/portal", { replace: true });
          } else {
            navigate("/portal/login?denied=1", { replace: true });
          }
        } else if (me.is_admin) {
          navigate("/admin", { replace: true });
        } else if (me.is_portal_member) {
          navigate("/portal", { replace: true });
        } else {
          navigate("/admin/login?denied=1", { replace: true });
        }
      } catch (e) {
        setError("Authentication failed. Please try again.");
        setTimeout(() => navigate("/admin/login", { replace: true }), 2000);
      }
    })();
  }, [navigate, setUser]);

  return (
    <main className="min-h-screen flex items-center justify-center text-slate-200 bg-atc-bg">
      <div className="flex flex-col items-center gap-4" data-testid="auth-callback">
        <Loader2 className="h-7 w-7 animate-spin text-atc-blue" />
        <div className="text-sm text-slate-400">{error || "Verifying your session…"}</div>
      </div>
    </main>
  );
};

export default AuthCallback;
